import { useEffect, useState } from 'react'
import api from '../api/client'
import { successModal, errorModal } from '../components/ui'
import Loader from '../components/Loader'

const GRUPOS = [
  ['Ativação & Conversão', [
    ['pv_min_ativo', 'PV pessoal mín./mês p/ ficar ATIVO', 'number'],
    ['conversao_servico_reais_por_pv', 'Serviço: R$ por 1 PV', 'number'],
    ['conversao_produto_reais_por_pv', 'Produto: R$ por 1 PV', 'number'],
    ['pv_validade_dias', 'Validade do PV (dias)', 'number'],
    ['ativ5_min_diretas', 'Diretas p/ contar Ativ5', 'number'],
  ]],
  ['Comissões (fallback global)', [
    ['comissao_direta_percentual', 'Comissão direta % (fallback)', 'number'],
    ['bonus_nivel1_percentual', 'Bônus nível 1 % (fallback)', 'number'],
    ['bonus_nivel2_percentual', 'Bônus nível 2 % (fallback)', 'number'],
  ]],
  ['Motor avançado', [
    ['compressao_dinamica', 'Compressão dinâmica (pula upline inativo)', 'bool'],
    ['corte_ro_inteligente', 'Corte inteligente de RO (diferencial)', 'bool'],
  ]],
  ['Licença & Indicação', [
    ['taxa_licenca_valor', 'Taxa de licença (R$)', 'number'],
    ['cashback_indicacao_pct', 'Cashback de indicação % (1ª fatura)', 'number'],
  ]],
  ['Carrinho · Frete & Impostos (configurável)', [
    ['frete_padrao', 'Frete padrão (R$) — 0 = grátis', 'number'],
    ['imposto_pct', 'Imposto % sobre o subtotal — 0 = não destaca', 'number'],
  ]],
  ['Parcelamento padrão (fallback global)', [
    ['parcelamento_max_parcelas', 'Máximo de parcelas', 'number'],
    ['parcelamento_parcelas_sem_juros', 'Parcelas sem juros', 'number'],
    ['parcelamento_taxa_juros_mensal', 'Taxa de juros % ao mês', 'number'],
  ]],
  ['Saque', [
    ['saque_valor_minimo', 'Valor mínimo de saque (R$)', 'number'],
    ['saque_prazo_dias', 'Prazo de processamento (dias úteis)', 'number'],
  ]],
  ['Profundidade de pagamento', [
    ['max_niveis_pagamento', 'Máx. níveis pagos (0 = ilimitado; Bronze 5 / Prata 10 / Ouro 15)', 'number'],
  ]],
  ['Loja & Termo', [
    ['loja_habilitada', 'Loja de Produtos Físicos habilitada (licenciados veem Loja/Fazer Pedidos)', 'bool'],
    ['loja_base_url', 'URL base da loja', 'text'],
    ['termo_aceite_texto', 'Texto do termo de aceite', 'textarea'],
  ]],
  ['Telecom', [
    ['telecom_cobra_chip', 'Cobrar o chip junto na 1ª fatura (plano + chip). Desligado = só o plano', 'bool'],
    ['telecom_chip_valor', 'Valor do chip (R$) — usado quando "cobrar chip" está ligado', 'number'],
  ]],
]

export default function ParametrosMLM() {
  const [p, setP] = useState(null)

  useEffect(() => { api.get('/parametros-mlm').then((r) => setP(r.data)).catch(() => {}) }, [])

  async function salvar() {
    try { const { data } = await api.put('/parametros-mlm', p); setP(data); successModal('Parâmetros do plano salvos!') }
    catch (e) { errorModal(e?.response?.data?.detail || 'Erro ao salvar') }
  }

  if (!p) return <div className="flex justify-center py-20"><Loader text="Carregando parâmetros..." /></div>

  return (
    <div className="max-w-3xl space-y-5">
      <div>
        <h1 className="text-2xl font-heading font-bold text-gray-900">Parâmetros do Plano MMN</h1>
        <p className="text-gray-500 text-sm mt-1">Regras globais do plano de carreira (refináveis). Comissões por faixa ficam em Plano de Carreira · Faixas.</p>
      </div>
      {GRUPOS.map(([titulo, campos]) => (
        <div key={titulo} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
          <p className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-3">{titulo}</p>
          <div className="grid sm:grid-cols-2 gap-4">
            {campos.map(([k, label, type]) => (
              <div key={k} className={type === 'textarea' ? 'sm:col-span-2' : ''}>
                {type === 'bool' ? (
                  <label className="flex items-center gap-2 text-sm text-gray-700 pt-5 cursor-pointer">
                    <input type="checkbox" checked={!!p[k]} onChange={(e) => setP({ ...p, [k]: e.target.checked })} className="w-4 h-4 accent-accent-500" />
                    {label}
                  </label>
                ) : (
                  <>
                    <label className="block text-xs font-medium text-gray-600 mb-1">{label}</label>
                    {type === 'textarea'
                      ? <textarea value={p[k] ?? ''} onChange={(e) => setP({ ...p, [k]: e.target.value })} rows={3}
                          className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400" />
                      : <input type={type} value={p[k] ?? ''} onChange={(e) => setP({ ...p, [k]: type === 'number' ? Number(e.target.value) : e.target.value })}
                          className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400" />}
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
      <button onClick={salvar} className="rounded-xl bg-gradient-to-r from-primary-500 to-accent-500 text-white px-6 py-2.5 font-semibold shadow-md hover:brightness-95">Salvar parâmetros</button>
    </div>
  )
}
